import React from "react";
import { ArrowUpRight, Clock3 } from "lucide-react";
import "./UsagePanel.css";

export function formatQuotaReset(timestamp, period, serverNow = Date.now() / 1000) {
  if (!timestamp) return "同步中";
  const options = { timeZone: "Asia/Shanghai", hourCycle: "h23" };
  if (period === "weekly") {
    if (timestamp - serverNow <= 86400) { options.hour = "2-digit"; options.minute = "2-digit"; }
    else { options.month = "2-digit"; options.day = "2-digit"; }
  } else { options.hour = "2-digit"; options.minute = "2-digit"; }
  return new Intl.DateTimeFormat("zh-CN", options).format(new Date(timestamp * 1000));
}

export function quotaPercent(quota) {
  if (!Number.isFinite(quota?.remaining_percent)) return null;
  return Math.max(0, Math.min(100, quota.remaining_percent));
}

export function quotaTone(percent) {
  if (percent === null) return "neutral";
  if (percent <= 20) return "critical";
  return percent <= 50 ? "warning" : "healthy";
}

function UsageRow({ label, caption, quota, period, now, emphasis = false }) {
  const percent = quotaPercent(quota);
  const display = percent === null ? "--" : percent > 0 && percent < 1 ? "<1%" : `${Math.round(percent)}%`;
  return <div className={`usage-row usage-tone-${quotaTone(percent)} ${emphasis ? "usage-row-weekly" : ""}`}>
    <div className="usage-row-top"><div><h4>{label}</h4>{caption && <p>{caption}</p>}</div><strong>{display}<small>剩余</small></strong></div>
    <div className="usage-track" role="progressbar" aria-label={`${label}剩余额度`} aria-valuetext={`${display}剩余`} aria-valuemin={0} aria-valuemax={100}
      {...(percent === null ? {} : { "aria-valuenow": percent })}>
      <span style={{ width: `${percent ?? 0}%` }} />
    </div>
    <div className="usage-reset"><Clock3 size={12} /><span>{period === "image" ? "每日零点重置" : `重置于 ${formatQuotaReset(quota?.reset_at, period, now)}`}</span></div>
  </div>;
}

export default function UsagePanel({ webUsage, apiUsage, onUpgrade }) {
  const snapshots = [webUsage, apiUsage].filter(Boolean).sort((a, b) => (b.server_now || 0) - (a.server_now || 0));
  const current = snapshots[0];
  const weekly = current?.weekly;
  const exhausted = weekly?.allowed === false;
  const mask = (quota) => exhausted && quota ? { ...quota, remaining_percent: 0 } : quota;
  const laneEmpty = webUsage?.chat?.allowed === false || apiUsage?.api_token?.allowed === false;
  const message = webUsage?.chat?.message || apiUsage?.api_token?.message || "当前额度已耗尽，请升级订阅以获取更多额度，或等待额度重置后继续使用。";
  return <section className="usage-panel" aria-label="账户用量">
    <div className="usage-panel-heading"><h3>用量</h3></div>
    <UsageRow label="总额度" caption="7 天周期" quota={weekly} period="weekly" now={current?.server_now} emphasis />
    <div className="usage-lanes">
      <UsageRow label="网页对话" quota={mask(webUsage?.chat)} period="lane" now={webUsage?.server_now} />
      <UsageRow label="API 调用" quota={mask(apiUsage?.api_token)} period="lane" now={apiUsage?.server_now} />
    </div>
    {(exhausted || laneEmpty) && <div className="usage-exhausted" role="status"><p>{message}</p><button type="button" onClick={onUpgrade}>查看订阅<ArrowUpRight size={14} /></button></div>}
    <UsageRow label="图片额度" quota={webUsage?.image} period="image" now={webUsage?.server_now} />
  </section>;
}
